import { render, staticRenderFns } from "./scope56.vue?vue&type=template&id=06ebb156&scoped=true"
import script from "./scope56.vue?vue&type=script&lang=js"
export * from "./scope56.vue?vue&type=script&lang=js"
import style0 from "./scope56.vue?vue&type=style&index=0&id=06ebb156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ebb156",
  null
  
)

export default component.exports